module.exports = __webpack_public_path__ + "bed-quilt2-empty.d0ea15bd.png";